import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { ServiceListFragmentDoc } from '../../ServicesList/__generated__/ServicesList.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetServicesByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetServicesByIdQuery = { __typename?: 'Query', getServiceById?: { __typename?: 'Services', id: string, desc: string, title: string, price: number, category: { __typename?: 'ServicesCategory', id: string, title: string } } | null };


export const GetServicesByIdDocument = gql`
    query getServicesById($id: ID!) {
  getServiceById(id: $id) {
    ...ServiceList
  }
}
    ${ServiceListFragmentDoc}`;

/**
 * __useGetServicesByIdQuery__
 *
 * To run a query within a React component, call `useGetServicesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServicesByIdQuery(baseOptions: Apollo.QueryHookOptions<GetServicesByIdQuery, GetServicesByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesByIdQuery, GetServicesByIdQueryVariables>(GetServicesByIdDocument, options);
      }
export function useGetServicesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesByIdQuery, GetServicesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesByIdQuery, GetServicesByIdQueryVariables>(GetServicesByIdDocument, options);
        }
export type GetServicesByIdQueryHookResult = ReturnType<typeof useGetServicesByIdQuery>;
export type GetServicesByIdLazyQueryHookResult = ReturnType<typeof useGetServicesByIdLazyQuery>;
export type GetServicesByIdQueryResult = Apollo.QueryResult<GetServicesByIdQuery, GetServicesByIdQueryVariables>;